export default "__VITE_ASSET__DUoccaCg__"